import * as React from 'react';

import { Modal } from 'security-app/components/common';
import DashboardsOverview from 'views/components/dashboard/DashboardsOverview';

type DashboardsModalProps = {
  show: boolean;
  onCancel: () => void;
};

const DashboardsModal = ({ show, onCancel }: DashboardsModalProps) => {
  const onClose = () => {
    onCancel();
  };

  return (
    <Modal show={show} title="Add Dashboards" onClose={onClose} maxWidth="1200px" closeOnBackdrop>
      <DashboardsOverview hideDelete hideShare hideAdditionalColumns />
    </Modal>
  );
};

export default DashboardsModal;
